
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-discounts",
      function () {
        return require("private-next-pages/my-discounts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-discounts"])
      });
    }
  